<script setup lang="ts">
import { ref } from "vue";
import router from "@/router";
import { pb } from "@/pocketbase"
import Button from '@/components/Button.vue';
import Input from '@/components/Input.vue';
import Heading from "@/components/Heading.vue";
import Error from "@/components/Error.vue";

const email = ref('');
const password = ref('');
const error = ref('');

async function login() {
  try {
    error.value = '';
    await pb.collection('users').authWithPassword(email.value, password.value);
    await router.push('/');
  } catch (e) {
    error.value = e.message;
  }
}
</script>

<template>
  <div class="space-y-2">
    <Heading>Sign In</Heading>

    <form @submit.prevent="login">
      <div class="shadow-sm">
        <Input v-model="email" id="email" name="email" label="Email" placeholder="you@example.com"/>
        <Input v-model="password" type="password" id="password" name="password" label="Password" placeholder="secret_password"/>
      </div>
      <Button label="Sign In" icon="lock"></Button>
    </form>

    <Error v-if="error">
      {{ error }}
    </Error>
  </div>
</template>

<style scoped lang="scss">
</style>
